import { render, staticRenderFns } from "./file.vue?vue&type=template&id=3396afd2&scoped=true&"
import script from "./file.vue?vue&type=script&lang=js&"
export * from "./file.vue?vue&type=script&lang=js&"
import style0 from "./file.vue?vue&type=style&index=0&id=3396afd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396afd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3396afd2')) {
      api.createRecord('3396afd2', component.options)
    } else {
      api.reload('3396afd2', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=3396afd2&scoped=true&", function () {
      api.rerender('3396afd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonFile/file.vue"
export default component.exports